import { useOrganizationId } from '@/hooks/useSwr';
import { appOrganizationPath, appSettingsPath } from '@/utils/constants';

import { Breadcrumb } from '../../components/Breadcrumbs';

export function SettingsCrumb() {
  const organizationId = useOrganizationId();
  return (
    <Breadcrumb
      path={`/${appOrganizationPath}/${organizationId}/${appSettingsPath}`}
      name={`Settings`}
      isActive
    />
  );
}
